import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import { advancedColors } from '../theme'

const visuallyHidden = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const

export const ExampleTag = () => (
  <Chip
    size="small"
    label="Example"
    sx={{
      height: 20,
      fontSize: '0.7rem',
      fontWeight: 700,
      flexShrink: 0,
      backgroundColor: advancedColors.yellowAccent,
      color: advancedColors.deep,
    }}
  />
)

// The watermark is aria-hidden, so this is what tells a screen reader the rows are not the patient's.
export const ExampleFeedNotice = () => (
  <Box role="note" sx={visuallyHidden}>
    Example rows for the tour. They are not this patient’s activity.
  </Box>
)

// Sits over the sample rows and stays put while the feed scrolls under it.
export const ExampleFeedWatermark = () => (
  <Box
    aria-hidden
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: 1,
      overflow: 'hidden',
      pointerEvents: 'none',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      alignContent: 'space-evenly',
      justifyItems: 'center',
      transform: 'rotate(-18deg) scale(1.2)',
    }}
  >
    {Array.from({ length: 8 }, (_, index) => (
      <Typography
        key={index}
        sx={{
          fontSize: '2rem',
          fontWeight: 800,
          letterSpacing: '0.16em',
          color: advancedColors.amber,
          opacity: 0.4,
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        EXAMPLE
      </Typography>
    ))}
  </Box>
)
